import StorePage from '../../components/pages/Store';

const Store: React.FC = () => {
  return <StorePage isBlockStoresView={false} />;
};

export default Store;
